import React, { useMemo, useContext, useState } from 'react';
import axios from 'axios';
import useDetailFetch from '../../../../hooks/useDetailFetch';
import { useParams, useNavigate } from 'react-router-dom';
import SingleItemDetailTemplate from '../../../Reusable_Components/SingleItemDetailTemplate';
import { API_ROUTES, API_DOMAIN, headers } from '../../../Reusable_Components/Config/apiConfig';
import { ToastContext } from '../../../../context/ToastContext';
import ConfirmModal from '../../../Reusable_Components/ConfirmModal';

const SingleOpportunitySubCategoryDetails = () => {
  const { subcategoryId } = useParams();
  const navigate = useNavigate();
  const { showToast } = useContext(ToastContext);

  const decodedId = subcategoryId ? atob(subcategoryId) : subcategoryId;
  const id = decodedId.replace(/\D/g, '');

  const [showDelete, setShowDelete] = useState(false);

  const url = id ? `${API_DOMAIN}${API_ROUTES['opportunitySubCategory']}${id}/` : null;
  const { data: details, loading } = useDetailFetch(url);

  const columns = useMemo(() => {
    if (!details) return null;
    const excluded = ['id', 'created_at', 'updated_at'];
    return Object.keys(details)
      .filter(c => !excluded.includes(c))
      .map(c => ({ label: c.charAt(0).toUpperCase() + c.slice(1), field: c }));
  }, [details]);

  const handleDelete = async () => {
    try {
      await axios.delete(API_DOMAIN + API_ROUTES['opportunitySubCategory'] + id + '/', { headers });
      showToast('Sub-Category deleted successfully', 'success');
      navigate('/opportunity/subcategory/list');
    } catch (error) {
      console.error('Error deleting SubCategory:', error);
      showToast('Failed to delete Sub-Category', 'error');
    }
  };

  return (
    <div>
      <SingleItemDetailTemplate
        details={details}
        columns={columns}
        loading={loading}
        entityName="Sub-Category"
        listPath="/opportunity/subcategory/list"
        editPath={`/opportunity/subcategory/input/${btoa(id)}`}
        onDelete={() => setShowDelete(true)}
      />
      <ConfirmModal
        open={showDelete}
        onConfirm={handleDelete}
        onCancel={() => setShowDelete(false)}
        title="Delete Sub-Category"
        message="Are you sure you want to delete this Sub-Category?"
      />
    </div>
  );
};

export default SingleOpportunitySubCategoryDetails;
